var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredLinkLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 96,
    r: 70,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 68L164 68",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 118L39 118",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 75L162 75",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 125L37 125",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171 68H175",
    stroke: "#D6D8DD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.481 130.488C120.516 128.749 120.516 127.036 122.166 124.574C125.257 119.805 127.03 114.1 127.03 107.694C127.03 88.3801 110.92 72.7219 91.0476 72.7219C71.1749 72.7219 55.0625 88.3714 55.0625 107.694C55.0433 111.422 55.6842 115.123 56.9557 118.627C58.0642 121.624 58.5119 126.628 56.0624 129.077C53.5171 131.623 49.107 132.029 47.5399 134.926C45.7772 138.174 48.2637 142.666 55.9863 141.645C58.6771 141.288 65.8628 137.463 68.6471 141.33C70.7511 144.251 78.2759 150.743 88.0329 146.722C99.5113 141.997 104.271 142.047 110.105 143.614C120.269 146.342 128.258 142.499 128.963 138.88C130.023 133.414 122.446 132.233 121.481 130.488Z",
    fill: "#D6D8DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4588 113.854C78.5139 113.854 80.1799 112.188 80.1799 110.133C80.1799 108.078 78.5139 106.412 76.4588 106.412C74.4037 106.412 72.7377 108.078 72.7377 110.133C72.7377 112.188 74.4037 113.854 76.4588 113.854Z",
    fill: "#838B98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.254 112.93C103.254 112.93 103.963 114.126 103.626 115.247C103.289 116.369 102.224 118.073 103.528 119.566C104.832 121.059 107.119 120.261 107.512 118.66C107.905 117.058 105.934 114.702 106.953 113.393C106.28 112.417 103.254 112.93 103.254 112.93Z",
    fill: "#F7F7F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.256 113.854C107.311 113.854 108.977 112.188 108.977 110.133C108.977 108.078 107.311 106.412 105.256 106.412C103.201 106.412 101.535 108.078 101.535 110.133C101.535 112.188 103.201 113.854 105.256 113.854Z",
    fill: "#838B98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.42 117.903C86.42 117.903 87.3481 115.156 90.9127 115.156C94.4773 115.156 95.2946 117.903 95.2946 117.903",
    stroke: "#838B98",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4132 69.9789L131.006 103.047L141.387 32.3833C142.112 27.4733 136.52 24.15 132.549 27.1277L75.4132 69.9789Z",
    fill: "#F7F7F8",
    stroke: "#838B98",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1514 70.8845L69.8304 73.1057C68.9947 74.511 69.4564 76.3276 70.8617 77.1633L126.854 110.462C128.259 111.298 130.076 110.836 130.911 109.431L132.232 107.209C133.068 105.804 132.606 103.987 131.201 103.152L75.209 69.8533C73.8037 69.0176 71.9871 69.4793 71.1514 70.8845Z",
    fill: "#F7F7F8",
    stroke: "#838B98",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredLinkLight);
export default __webpack_public_path__ + "static/media/expired-link-light.dc8e582c7544920d21cd1b2dee409330.svg";
export { ForwardRef as ReactComponent };